import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import localePT from '@angular/common/locales/pt';
import localeKo from '@angular/common/locales/ko';
import { LoadingScreenComponent } from './shared/loading-screen/loading-screen.component';
import { ErrorComponent } from './error/error.component';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS
} from "@angular/common/http";
import { ConfigModule, ConfigService, ConfigLoader } from "@ngx-config/core";
import { ConfigHttpLoader } from "@ngx-config/http-loader";
import { registerLocaleData, CommonModule, ViewportScroller } from '@angular/common';
import { TranslateModule } from 'shared/translate/translate.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TRANSLATION_PROVIDERS, TranslateService } from 'shared/translate';
import { BaseService } from './services/base.service';
import { AutenticacaoService } from './services/autenticacao.service';
import { AuthenticationGuard } from './shared/authentication.guard';
import { LoadingScreenInterceptor } from './services/loading.interceptor';
import { AutenticacaoInterceptor } from './services/autenticacao.interceptor';
import { ErroService } from './services/erro.service';
import { PlataformaService } from './services/plataforma.service';
import { LoginComponent } from './login/login.component';
import { NgSelectModule } from '@ng-select/ng-select';
import {SelecionaIdiomaModule} from 'shared/selecionaidioma/selecionaidioma.module';
import { ExibeErroModule } from 'shared/exibe-erro/exibe-erro.module';
import { LoginFormComponent } from './login/login-form/login-form.component';
import { FormsModule } from '@angular/forms';
import { ChangePasswordComponent } from './login/change-password/change-password.component';
import { NavegacaoPaginaService } from './services/navegacaopagina.service';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale, koLocale } from 'ngx-bootstrap/locale';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { filter } from 'rxjs/operators';
import { Router, Scroll,Event } from '@angular/router';
import { UsuarioService } from './services/usuario.service';
import { ParametroService } from './services/parametro.service';
import { AceitacaoAcessoComponent } from './login/aceitacao-acesso/aceitacao-acesso.component';
import { ModalModule } from 'ngx-bootstrap/modal';
export function configFactory(http: HttpClient): ConfigLoader {
  return new ConfigHttpLoader(http, "./config.json"); // API ENDPOINT
}
defineLocale('pt-br', ptBrLocale);
defineLocale('ko-kr', koLocale);
registerLocaleData(localePT);
registerLocaleData(localeKo);
@NgModule({
  declarations: [
    AppComponent,
    LoadingScreenComponent,
    ErrorComponent,    
    LoginComponent,
    LoginFormComponent,
    ChangePasswordComponent,
    AceitacaoAcessoComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ConfigModule,
    SelecionaIdiomaModule,
    BrowserAnimationsModule,
    NgSelectModule,
    ExibeErroModule,
    TranslateModule.forRoot(),
    ConfigModule.forRoot({
        provide: ConfigLoader,
        useFactory: configFactory,
        deps: [HttpClient]
    }),
    FontAwesomeModule,    
    ModalModule.forRoot()
  ],
  providers: [TRANSLATION_PROVIDERS,
    TranslateService,
    BaseService,
    AutenticacaoService,
    UsuarioService,
    AuthenticationGuard,
    PlataformaService,
    NavegacaoPaginaService,
    ParametroService,
    ErroService,
    {
        provide: HTTP_INTERCEPTORS,
        useClass: LoadingScreenInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AutenticacaoInterceptor,
        multi: true
    }, 
    { provide: LOCALE_ID, useValue: 'pt-br' },],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor(router: Router, viewportScroller: ViewportScroller) {
  router.events.pipe(
    filter((e: Event): e is Scroll => e instanceof Scroll)
  ).subscribe(e => {
    if (e.position) {
      // backward navigation
      viewportScroller.scrollToPosition(e.position);
    } else if (e.anchor) {
      // anchor navigation
      viewportScroller.scrollToAnchor(e.anchor);
    } else {
      // forward navigation
      viewportScroller.scrollToPosition([0, 0]);
    }
  }); 
  }
}
